import { ElementRef, Output, EventEmitter, Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[ncClickOutside]'
})
export class ClickOutsideDirective {

    constructor(private _elementRef: ElementRef) { }
    /** 触发点击外部事件 */
    @Output() public ncClickOut = new EventEmitter<MouseEvent>();

    @HostListener('document:click', ['$event', '$event.target'])
    public onClick(event: MouseEvent, targetElement: EventTarget | null): void {
        if (!targetElement || !(targetElement instanceof HTMLElement)) {
            return;
        }
        // targetElement is now narrowed to HTMLElement ✓
        const clickedInside = this._elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.ncClickOut.emit(event);
        }
    }
}
